
import React from "react"
import './OptionalTag.scss'

export const OptionalTag = ({...props}) => {
    return (
        <div {...props} className="text-small box">optional</div>
    )
}